import {Box, Checkbox, Grid, InputLabel, MenuItem, Select, Typography, FormControl, DialogTitle, Dialog, Paper} from "@material-ui/core";
import {DataGrid, GridValueGetterParams} from "@material-ui/data-grid";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import {makeStyles} from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Avatar from '@material-ui/core/Avatar';
import _ from "lodash";
import DriverDetailDialog from "./DriverDetailDialog";
import {showAlertSnackbar} from "../../reducers/uiSlice";
import {getDriverBasic} from "../../actions/driverAppApprovalActions";
import {getDeliveryRealTimeDetails} from "../../actions/deliveryEfficiencyMonitorAction";
import StatusDetailDialog from "./StatusDetailDialog";
import DialogCloseableTitle from "../Common/DialogCloseableTitle";
import CloudDownloadIcon  from '@material-ui/icons/CloudDownload';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,

    }, leftSection: {
        paddingTop: theme.spacing(3),

        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',

    }, dialog: {
        overflow: 'auto',
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    }
}));

function TableSection(props) {
    const {t} = useTranslation('driverEfficiencyMonitor');
    const dispatch = useDispatch();
    const classes = useStyles();
    const PAGE_SIZE = 20;
    const [express, setExpress] = useState('');
    const [openTipsDialog, setOpenTipsDialog] = useState(false);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [selectRowId, setSelectRowId] = useState('');
    const [selectPartner, setSelectPartner] = useState('');
    const [driverInfo, setDriverInfo] = useState();
    const [detailType, setDetailType] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [statusInfo, setStatusInfo] = useState();
    const SEARCHABLE_STATUS_LIST = [200, 202, 211, 213, 231, 232, 203];
    const [isDataLoading, setIsDataLoading] = useState(false);
    const statusCodes = [
        {
            id: 200,
            text: 'PARCEL SCANNED'
        },
        {
            id: 202,
            text: 'IN TRANSIT'
        },
        {
            id: 211,
            text: 'RETURN OFFICE FROM TRANSIT'
        },
        {
            id: 213,
            text: 'STORAGE 30 DAYS FROM OFFICE'
        },
        {
            id: 231,
            text: 'FAILED DELIVERY RETRY 1'
        },
        {
            id: 232,
            text: 'FAILED DELIVERY RETRY 2'
        },
        {
            id: 203,
            text: 'DELIVERED'
        }
    ];
    const completionRates = [
        {
            id: 0,
            level: 1,
            color: '#B24848'
        },
        {
            id: 1,
            level: 2,
            color: '#D1713E'
        },
        {
            id: 2,
            level: 3,
            color: '#E3A10A'
        },
        {
            id: 3,
            level: 4,
            color: '#7C8417'
        },
        {
            id: 4,
            level: 5,
            color: '#47886F'
        }];
    const inactiveRulesList = [
        {
            id: 0,
            level: 1,
            color: 'orange'
        },
        {
            id: 1,
            level: 2,
            color: 'red'
        },
        {
            id: 2,
            level: 3,
            color: '#47886F'
        }];
    const driverDetailsColumns = [
        {
            field: 'team_name',
            headerName: t('team'),
            width: 80,
            headerAlign: 'center',
            align: 'center',
            flex: 0.8,
            renderCell: (params) => (
                <div>
                    {(params?.value) || "N/A"}
                </div>
            ),

        },
        {
            field: 'shipping_staff_id',
            headerName: t('driver_id'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.8
        },
        {
            field: '200',
            headerName: t('200'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            filterable: false,
            editable: false,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'darkgray'} : {color: 'Orange'}}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: '202',
            headerName: t('202'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            filterable: false,
            editable: false,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'darkgray'} : {color: 'Orange'}}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: '211',
            headerName: t('211'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            filterable: false,
            editable: false,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'darkgray'} : {color: 'Orange'}}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: '213',
            headerName: t('213'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            filterable: false,
            editable: false,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'darkgray'} : {color: 'Orange'}}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: '231',
            headerName: t('231'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            filterable: false,
            editable: false,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'darkgray'} : {color: 'Orange'}}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: '232',
            headerName: t('232'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            filterable: false,
            editable: false,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'darkgray'} : {color: 'Orange'}}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: '203',
            headerName: t('203'),
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            width: 100,
            filterable: false,
            editable: false,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'darkgray'} : {color: 'Orange'}}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'to_be_delivered/total',
            colSpan: 2,
            headerName: t('to_be_delivered/total'),
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            sortable: false,
            filterable: false,
            valueGetter: getCompareRate,
        },

        {
            field: 'done_ratio',
            headerName: t('completion_rate'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'white'} : {color: 'Orange'}}
                >
                    <Avatar style={{
                        width: 100,
                        height: 36,
                        backgroundColor: checkLevelColor(params.value/100, props.completionRules, completionRates)
                    }}
                            variant="rounded">
                        <span style={{
                            color: "white",
                            fontWeight: 'bold',
                            fontSize: 14
                        }}>{parseFloat(params.value).toFixed(1)}%</span>
                    </Avatar>
                </div>
            ),
        },
        {
            field: 'first_update',
            headerName: t('first_update'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 1
        },
        {
            field: 'first_idle_interval',
            headerName: t('first_to_current'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params) => (
                <div
                >
                    {params.value || 'N/A'}
                </div>
            ),
        },
        {
            field: 'last_update',
            headerName: t('last_update'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 1
        },
        {
            field: 'idle_interval',
            headerName: t('inactive_time'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params) => (
                <div
                    style={{color: checkLevelColor(params.value, props.inactiveRule, inactiveRulesList)}}
                >
                    {params.value || 'N/A'}
                </div>
            ),
        },
    ];

    const handleCellClick = (selectedCell) => {
        if (props.isDataLoading === false && selectedCell.value>0) {
            setSelectedState(selectedCell.field)
            showDriverDetail(selectedCell)
        }
    }
    const handleDetailClosed = () => {
        setDetailType('')
        setDriverInfo()
    }
    const handleStatusDetailClosed = () => {
        setDetailType('')
        setStatusInfo()
    }

    useEffect(() => {
        if (express != '') {
            setOpenDetailsDialog(true);
        }
    }, [express])
    useEffect(() => {
        if (selectPartner != 0) {
            props.handleSelectPartner(selectPartner);
        }
    }, [selectPartner])

    return (
        <Box style={{margin: 30, paddingRight: 10}}>
            <Grid
                container
                alignItems="center"
                justify="left"
            >
                <Grid item xs={1}>
                    <div style={{color: 'lightgray'}}>
                        <span>{t('total_orders')}:</span>
                        <span style={{color: 'white'}}> {props.allDriverDetails?.total_count}</span>
                    </div>
                </Grid>
                <Grid item xs={1}>
                    <div style={{color: 'lightgray'}}>
                        <span>{t('completion_rate')}:</span>
                        <span style={{color:checkTotalCompleteRate(props.allDriverDetails?.total_done_ratio, props.completionRules, completionRates)}}> {props.allDriverDetails?.total_done_ratio}</span>
                    </div>
                </Grid>
                <Grid item xs={1} style={{marginLeft: 30}}>
                    <div style={{color: 'grey'}}>
                        <Checkbox
                            color='secondary'
                            checked={props.selectedExpress}
                            onChange={(e) => {
                                props.handleSelectExpress(e.target.checked)
                            }}
                            id="tablesection_selectedexpress_checkbox"
                        />
                        <span style={{color: 'lightgray'}}>{t('express')}</span>
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        size="small"
                    >
                        <InputLabel>{t('partner')}</InputLabel>
                        <Select
                            value={props.selectedPartner}
                            onChange={(event) => {
                                props.handleSelectPartner(event.target.value)
                            }}
                            id="tablesection_selectedpartner_select"
                        >
                            <MenuItem value={0}>All Partners </MenuItem>
                            {props.allDriverDetails?.partner_list?.map((partner) => {
                                return <MenuItem key={partner.partner_id}
                                                 value={partner.partner_id}>{partner.name}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid
                    xs={2}
                    justify="center"
                    container
                    style={{flexGrow: 1}}
                >
                    <div style={{color: 'lightgray', alignItems: 'flex-end'}}>
                        <span>{t('table_tips')}</span>
                        <IconButton
                            onClick={() => setOpenTipsDialog(true)}
                            size="small"
                            style={{color: 'grey'}}
                            id="tablesection_tabletips_iconbutton"
                        >
                            <HelpOutlinedIcon size={'small'}/>
                        </IconButton>
                    </div>
                </Grid>
                <div style={{color: 'lightgray', alignItems: 'flex-end',marginLeft: 'auto'}}>
                    <IconButton
                        disabled={_.isEmpty(props.allDriverDetails?.delivery_data)||props.isDataLoading}
                        onClick={(e) => {
                            props.handleDownloadResult()
                        }}
                        id="tablesection_downloadresult_iconbutton"
                    >
                        <CloudDownloadIcon size={'small'}/>
                    </IconButton>
                </div>
            </Grid>
            <DataGrid
                columns={driverDetailsColumns}
                rows={props.allDriverDetails?.delivery_data || []}
                pagination
                pageSize={PAGE_SIZE}
                alignItems="center"
                rowsPerPageOptions={[PAGE_SIZE]}
                rowCount={props.allDriverDetails?.delivery_data?.length || 0}
                loading={props.isDataLoading}
                getRowId={(row) => row.shipping_staff_id}
                disableSelectionOnClick
                onPageChange={(newPage) => {
                    props.setPage(newPage + 1);
                }}
                onSelectionModelChange={(newSelection) => {
                    props.setSelectedItems(newSelection);
                }}
                style={{height: '100vh'}}
                onCellClick={(selectedCell) => handleCellClick(selectedCell)}
            />
            <Box>
                <Dialog
                    title="Status codes and completion rate"
                    open={openTipsDialog}
                    onClose={() => {
                        setOpenTipsDialog(false)
                    }}
                    maxWidth='sm'
                    classes={{paper: classes.dialog}}
                    fullWidth
                >
                    <DialogCloseableTitle onClose={() => {
                        setOpenTipsDialog(false)
                    }}>
                        {"Status codes and completion rate"}
                    </DialogCloseableTitle>
                    <Typography style={{padding: 10, marginLeft: 10}}>{t('status_codes')}
                    </Typography>
                    {statusCodes.map((statusCode) => (
                        <Grid xs={12} item style={{padding: 5, marginLeft: 20}}>
                            {
                                <div>
                                    <span style={{color: '#A3A4A0'}}>{statusCode.id}: </span>
                                    <span style={{color: '#FFFFFF'}}>{statusCode.text} </span>
                                </div>
                            }
                        </Grid>
                    ))}
                    <Paper style={{backgroundColor: '#292929'}}>
                        <Typography style={{paddingTop: 20, paddingLeft: 20}}>{t('completion_rate')}</Typography>
                        <Grid
                            container
                            alignItems="left"
                            justify="left"
                            style={{marginBottom: 10, paddingLeft: 20}}
                        >
                            {props.completionRules.map((completionRule) => (
                                <Grid xs={2} item style={{marginLeft: 10}}>
                                    <div className={classes.leftSection}>
                                        <Avatar style={{
                                            width: 100,
                                            height: 36,
                                            backgroundColor: showColor(completionRates, completionRule.level)
                                        }} variant="rounded">
                                            <span
                                                style={{fontSize: 14}}>{completionRule.min_value * 100 + "-" + completionRule.max_value * 100 + "%"}</span>
                                        </Avatar>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </Paper>
                </Dialog>
                <DriverDetailDialog
                    detailType={detailType}
                    driverInfo={driverInfo}
                    handleDetailClosed={handleDetailClosed}
                />
                <StatusDetailDialog
                    detailType={detailType}
                    driverInfo={driverInfo}
                    handleDetailClosed={handleStatusDetailClosed}
                    statusInfo={statusInfo}
                    selectedTeam={props.selectedTeam}
                    selectRowId={selectRowId}
                    partnerName={showPartnerName()}
                    selectedExpress={props.selectedExpress}
                    currentState={showCurrentState()}
                />
            </Box>
        </Box>
    );

    function showDriverDetail(selectedCell) {
        if (selectedCell.field === 'shipping_staff_id') {
            props.handleDataLoading(true)
            setDetailType('driver_info')
            dispatch(getDriverBasic(selectedCell.value))
                .then((res) => {
                    setDriverInfo(_.defaults(res, {driver_id: selectedCell.value}))
                    props.handleDataLoading(false)
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: "System cannot get driver detail", type: 'error'}))

                })
                .finally(() => {
                    props.handleDataLoading(false)
                })
        }
        if (SEARCHABLE_STATUS_LIST.includes((selectedCell.field * 1))) {
            props.handleDataLoading(true)
            setDetailType('status_detail');
            let params = {
                sub_references: props.selectedInput,
                team_id: props.selectedTeam,
                driver_id: selectedCell.id,
                state: selectedCell.field
            }
            if (props.selectedPartner != 0 && props.selectedPartner != '') {
                params.partner_id = props.selectedPartner
            }
            if (props.selectedExpress != null) {
                params.is_express = props.selectedExpress
            }
            dispatch(getDeliveryRealTimeDetails(params))
                .then((res) => {
                    setStatusInfo(res)
                    setSelectRowId(selectedCell.id)
                    props.handleDataLoading(false);
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: "System cannot get status detail", type: 'error'}))
                })
                .finally(() => {
                    props.handleDataLoading(false)
                })
        }
    }

    function getCompareRate(params: GridValueGetterParams) {
        return `${params.row.undo_count || ''}` + ' /' + ` ${params.row.total_count || ''}`;
    }

    function showColor(Rules, level) {
        let result = _.filter(Rules, (item) => {
            return item.level === level;
        });
        if (!_.isEmpty(result))
            return result[0].color
        else return "N/A"
    }

    function checkTotalCompleteRate(data, completionRules, completionRates) {
        if (!_.isNil(data)) {
            let rate = parseFloat(data.split("%")) / 100
            if (!_.isNil(rate)) {
                return checkLevelColor(rate, completionRules, completionRates)
            }
        }
    }

    function checkLevelColor(data, Rules, RulesList) {
        if (!_.isNil(data)) {
            let filterLevel = _.filter(
                Rules, (item) => {
                    return parseFloat(item.max_value) >= parseFloat(data) && parseFloat(item.min_value) <= parseFloat(data);
                })
            if (_.isEmpty(filterLevel)) {
                filterLevel = Rules.slice(-1);
            }
            return showColor(RulesList, filterLevel[0].level);
        }
    }

    function showPartnerName() {
        let result = _.filter(props.partnerList, (item) => {
            return item.partner_id === props.selectedPartner;
        });
        if (!_.isEmpty(result)) {
            return result[0].name;
        }
        return "N/A"
    }

    function showCurrentState() {
        let currentState = _.filter(statusCodes, (item) => {
            return item.id === selectedState * 1;
        });
        if (!_.isEmpty(currentState)) {
            return currentState[0].id + " (" + currentState[0].text + ")";
        }
        return " N/A"
    }
}

export default TableSection;